import React from 'react'
import './gstreports.css'
import GSTReportTable from '../../components/GST Reports/GSTReportTable'
import CompanyDashboard from '../../components/companies/CompanyDashboard'
const GSTReportTableMain = () => {
  return (
    <div>
        {/* <CompanyDashboard/> */}
       <GSTReportTable/>
    </div>
  )
}

export default GSTReportTableMain
